import AudioModel from './src/AudioModel.vue'

AudioModel.install = function(Vue) {
    Vue.component(AudioModel.name, AudioModel)
}

export default AudioModel